import Vue from "vue";
import _ from "lodash";
import { db, docsFromSnapshot, docFromSnapshot } from "@/firebase";
import { omitUndefinedDeep } from "@/helpers/helpers";

const SET_SERVICES = "SET_SERVICES";
const SET_SERVICE = "SET_SERVICE";
const REMOVE_SERVICE = "REMOVE_SERVICE";

const state = {
  services: {}
};

const getters = {
  services: state => state.services,
  servicesList: state => _.sortBy(state.services, "name"),
  servicesEnabled: state =>
    _.reduce(
      Object.values(state.services),
      (services, service) => {
        if (!service || !service.enabled) return services;
        const id = service._id || service.id;
        if (id) services[id] = service;
        return services;
      },
      {}
    ),
  serviceById: state => id => state.services[id]
};

const actions = {
  async createService(context, service) {
    const ref = db.collection("services").doc();

    service = omitUndefinedDeep({
      ...service,
      _id: ref.id,
      tenantId: context.rootGetters.tenantId,
      lastModified: +new Date(),
      storeId: _.get(context,"rootGetters.userClaims.storeId"),
      created: +new Date()
    });

    await ref.set(service);
    context.commit(SET_SERVICE, service);
  },
  async fetchServices(context) {
    const snap = await db
      .collection("services")
      .where("storeId", "==", context.rootGetters.userClaims.storeId)
      .get();
    const docs = docsFromSnapshot(snap);
    context.commit(SET_SERVICES, docs);
  },
  async fetchService(context, id) {
    const snap = await db
      .collection("services")
      .doc(id)
      .get();
    const doc = docFromSnapshot(snap);
    context.commit(SET_SERVICE, doc);
  },
  async updateService(context, service) {
    service.lastModified = +new Date();
    await db
      .collection("services")
      .doc(service._id)
      .set(service);
    context.commit(SET_SERVICE, service);
  },
  async deleteService(context, { _id }) {
    await db
      .collection("services")
      .doc(_id)
      .delete();
    context.commit(REMOVE_SERVICE, _id);
  }
};

const mutations = {
  [SET_SERVICES](state, services) {
    state.services = services;
  },
  [SET_SERVICE](state, service) {
    Vue.set(state.services, service._id, service);
  },
  [REMOVE_SERVICE](state, id) {
    state.services = _.omit(state.services, [id]);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
